import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TourCardV2, Carousel } from 'views/rebranded-module/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  '& .IRSSectionContainer': {
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0),
    },
  },
  '& .TSContent': {
    '& .IRSubTitle': {
      maxWidth: theme.typography.pxToRem(740),
    },
  },
  '& .TSCardWapper': {
    width: '100%',
  },
}));
export const StyledTourCardV2 = styled(TourCardV2)(({ theme }) => ({
  '& .TCImgContainer': {
    height: theme.spacing(38.5),
  },
}));
export const StyledCarousel = styled(Carousel)(({ theme }) => ({
  '& .CCarouselItem': {
    paddingLeft: `${theme.spacing(0.25)} !important`,
    display: 'flex',
    alignItems: 'stretch',
    height: 'auto',
  },
}));

export default StyledBox;
